import { marketExplorerClient } from '@/features/stockchart/explorer/marketExplorerClient';
import { normalizeMarketQuery } from '@/features/charting-next/models/chartingMarketQuery';

export const chartingMarketQueryRepository = {
    createCancelSource: () => marketExplorerClient.createCancelSource(),
    execute: (definition, config = {}) => marketExplorerClient.execute(normalizeMarketQuery(definition), config),
    getLast: (config = {}) => marketExplorerClient.getLast(config),
    saveLast: (definition) => marketExplorerClient.saveLast(normalizeMarketQuery(definition)),
    deleteLast: () => marketExplorerClient.deleteLast(),
    listSaved: () => marketExplorerClient.listSaved(),
    getSaved: (name) => marketExplorerClient.getSaved(name),
    saveNamed: (name, definition) => marketExplorerClient.saveNamed(name, normalizeMarketQuery(definition)),
    updateNamed: (name, input) => marketExplorerClient.updateNamed(name, input),
    deleteNamed: (name) => marketExplorerClient.deleteNamed(name)
};
